var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('div',{attrs:{"id":"list_menu"}},[_c('router-link',{attrs:{"to":"/awards/"}},[_vm._v("Правила - Rules")]),_c('router-link',{attrs:{"to":"/awards/issued"}},[_vm._v("Выданные дипломы - Issued awards")]),_c('router-link',{attrs:{"to":"/awards/gallery"}},[_vm._v("Галерея - Gallery")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }